import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

/**
 * Shown when a dynamically imported route chunk fails to load (e.g. after dev server
 * restart, stale cache, or opening the same URL later). Prompts the user to reload
 * so the app fetches the current chunk.
 */
export default function ChunkLoadError() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Box sx={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', px: 2, gap: 2 }}>
      <Typography variant="h5" color="text.primary" textAlign="center">
        Something went wrong loading this page
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center" maxWidth={400}>
        The app may have been updated or your session is stale. Reloading the page usually fixes this.
      </Typography>
      <Button variant="contained" onClick={handleReload}>
        Reload page
      </Button>
    </Box>
  );
}
